const number = (options) => ({
    type: 'number',
    default: options?.default,
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const string = (options) => ({
    type: 'string',
    default: options?.default,
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const boolean = (options) => ({
    type: 'boolean',
    default: options?.default,
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const nullable = (options) => ({
    type: 'nullable',
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const notDefined = (options) => ({
    type: 'notDefined',
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const any = (options) => ({
    type: 'any',
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const unknown = (options) => ({
    type: 'unknown',
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const fn = (options) => ({
    type: 'function',
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const array = (items, options) => ({
    type: 'array',
    items,
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const record = (key, value, options) => ({
    type: 'record',
    key,
    value,
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const object = (properties, options) => ({
    type: 'object',
    properties,
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
/**
 * The conditional return type mirrors {@link intersection}: lightweight input constraint,
 * precise `UnionSchema<Schemas>` output without re-triggering eager evaluation.
 */
const union = (schemas, options) => ({
    type: 'union',
    schemas,
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
/**
 * The conditional return type is what unlocks circular `intersection([... lazy(() => self) ...])`.
 *
 * The input constraint is the lightweight `IntersectionMember` (discriminant-only) so the call-site
 * constraint check does not force TypeScript to eagerly evaluate each tuple element. The conditional
 * `Schemas extends readonly Schema[]` is always true in practice (every passed value is a real schema)
 * and lets us produce a precise `IntersectionSchema<Schemas>` without re-introducing the heavy check.
 */
const intersection = (schemas, options) => ({
    type: 'intersection',
    schemas,
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const optional = (schema, options) => ({
    type: 'optional',
    schema,
    typeName: options?.typeName,
    typeComment: options?.typeComment,
});
const literal = (value) => ({
    type: 'literal',
    value,
});
const lazy = (schema) => ({
    type: 'lazy',
    schema,
});
const evaluate = (expression, schema) => ({
    type: 'evaluate',
    expression,
    schema,
});
export { any, array, boolean, evaluate, fn, intersection, lazy, literal, notDefined, nullable, number, object, optional, record, string, union, unknown, };
